// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__Zho+4","layout-container":"Avatar_layout-container__A7UF6","pageContainer":"Avatar_pageContainer__43Toz","spinnerWrapper":"Avatar_spinnerWrapper__QmrsK","container":"Avatar_container__EoEv7","formWrapper":"Avatar_formWrapper__hmCHe","navContainer":"Avatar_navContainer__3qzsU"};
    if(module.hot) {
      // 1763464084228
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  